import { get as _get } from 'lodash';

export function getSubtitles(clipdetails) {
  // English subtitle
  const english = {
    file: _get(clipdetails, 'subtitle_en_vtt'),
    kind: 'captions',
    label: 'English'
  };
  const indonesian = {
    file: _get(clipdetails, 'subtitle_id_vtt'),
    kind: 'captions',
    label: 'Indonesian'
  };

  const malaysian = {
    file: _get(clipdetails, 'subtitle_ms_vtt'),
    kind: 'captions',
    label: 'Malaysian'
  };

  const Chinese = {
    file: _get(clipdetails, 'subtitle_zh-cn_vtt'),
    kind: 'captions',
    label: '中文'
  };
  const SChinese = {
    file: _get(clipdetails, 'subtitle_zh-CN_vtt'),
    kind: 'captions',
    label: '中文'
  };
  const TChinese = {
    file: _get(clipdetails, 'subtitle_zh-TW_vtt'),
    kind: 'captions',
    label: 'T.Chinese'
  };
  const tChinese = {
    file: _get(clipdetails, 'subtitle_zh-tw_vtt'),
    kind: 'captions',
    label: 'T.Chinese'
  };

  const BurmeseUnicode = {
    file: _get(clipdetails, 'subtitle_mya_vtt'),
    kind: 'captions',
    label: 'မြန်မာ ယူနီကုဒ်'
  };
  const Arabic = {
    file: _get(clipdetails, 'subtitle_ar_vtt'),
    kind: 'captions',
    label: 'عربى'
  };
  const Thai = {
    file: _get(clipdetails, 'subtitle_th_vtt'),
    kind: 'captions',
    label: 'ไทย'
  };
  const Filipino = {
    file: _get(clipdetails, 'subtitle_fil_vtt'),
    kind: 'captions',
    label: 'Filipino'
  };
  const Hindi = {
    file: _get(clipdetails, 'subtitle_hi_vtt'),
    kind: 'captions',
    label: 'हिंदी'
  };
  const Tamil = {
    file: _get(clipdetails, 'subtitle_ta_vtt'),
    kind: 'captions',
    label: 'தமிழ்'
  };
  const Telugu = {
    file: _get(clipdetails, 'subtitle_te_vtt'),
    kind: 'captions',
    label: 'తెలుగు'
  };
  const Marathi = {
    file: _get(clipdetails, 'subtitle_mr_vtt'),
    kind: 'captions',
    label: 'मराठी'
  };
  const Malayalam = {
    file: _get(clipdetails, 'subtitle_ml_vtt'),
    kind: 'captions',
    label: 'മലയാളം'
  };
  const Urdu = {
    file: _get(clipdetails, 'subtitle_ur_vtt'),
    kind: 'captions',
    label: 'اردو'
  };
  const Vietnamese = {
    file: _get(clipdetails, 'subtitle_vi_vtt'),
    kind: 'captions',
    label: 'Tiếng Việt'
  };
  return [
    english,
    indonesian,
    malaysian,
    Chinese,
    SChinese,
    TChinese,
    BurmeseUnicode,
    tChinese,
    Arabic,
    Thai,
    Filipino,
    Hindi,
    Tamil,
    Telugu,
    Urdu,
    Marathi,
    Malayalam,
    Vietnamese
  ];
}

export function getSubtitlesForNewPlayer(clipdetails) {
  // English subtitle
  const english = {
    url: _get(clipdetails, 'subtitle_en_vtt'),
    file: _get(clipdetails, 'subtitle_en_vtt'),
    kind: 'caption',
    id: '1',
    label: 'English',
    lang: 'english'
  };
  const indonesian = {
    url: _get(clipdetails, 'subtitle_id_vtt'),
    file: _get(clipdetails, 'subtitle_id_vtt'),
    kind: 'subtitle',
    label: 'Indonesian',
    id: '2',
    lang: 'indonesian'
  };

  const malaysian = {
    url: _get(clipdetails, 'subtitle_ms_vtt'),
    file: _get(clipdetails, 'subtitle_ms_vtt'),
    kind: 'subtitle',
    label: 'Malaysian',
    id: '3',
    lang: 'malaysian'
  };

  const Chinese = {
    url: _get(clipdetails, 'subtitle_zh-cn_vtt'),
    file: _get(clipdetails, 'subtitle_zh-cn_vtt'),
    kind: 'subtitle',
    label: '中文',
    id: '4',
    lang: 'chinese'
  };
  const SChinese = {
    url: _get(clipdetails, 'subtitle_zh-CN_vtt'),
    file: _get(clipdetails, 'subtitle_zh-CN_vtt'),
    kind: 'subtitle',
    label: '中文',
    id: '5',
    lang: 'chinese'
  };
  const TChinese = {
    url: _get(clipdetails, 'subtitle_zh-TW_vtt'),
    file: _get(clipdetails, 'subtitle_zh-TW_vtt'),
    kind: 'subtitle',
    label: 'T.Chinese',
    id: '6',
    lang: 'chinese'
  };
  const tChinese = {
    url: _get(clipdetails, 'subtitle_zh-tw_vtt'),
    file: _get(clipdetails, 'subtitle_zh-tw_vtt'),
    kind: 'subtitle',
    label: 'T.Chinese',
    id: '7',
    lang: 'chinese'
  };
  const BurmeseUnicode = {
    file: _get(clipdetails, 'subtitle_mya_vtt'),
    url: _get(clipdetails, 'subtitle_mya_vtt'),
    kind: 'subtitle',
    label: 'မြန်မာ ယူနီကုဒ်',
    id: '8',
    lang: 'burmese'
  };
  const Arabic = {
    url: _get(clipdetails, 'subtitle_ar_vtt'),
    file: _get(clipdetails, 'subtitle_ar_vtt'),
    kind: 'subtitle',
    label: 'عربى',
    id: '9',
    lang: 'arabic'
  };
  const Thai = {
    url: _get(clipdetails, 'subtitle_th_vtt'),
    file: _get(clipdetails, 'subtitle_th_vtt'),
    kind: 'subtitle',
    label: 'ไทย',
    id: '10',
    lang: 'thai'
  };
  const Filipino = {
    url: _get(clipdetails, 'subtitle_fil_vtt'),
    file: _get(clipdetails, 'subtitle_fil_vtt'),
    kind: 'subtitle',
    label: 'Filipino',
    id: '11',
    lang: 'thai'
  };
  const Hindi = {
    url: _get(clipdetails, 'subtitle_hi_vtt'),
    file: _get(clipdetails, 'subtitle_hi_vtt'),
    kind: 'subtitle',
    label: 'हिंदी',
    id: '12',
    lang: 'hindi'
  };
  const Tamil = {
    url: _get(clipdetails, 'subtitle_ta_vtt'),
    file: _get(clipdetails, 'subtitle_ta_vtt'),
    kind: 'subtitle',
    label: 'தமிழ்',
    id: '13',
    lang: 'tamil'
  };
  const Telugu = {
    url: _get(clipdetails, 'subtitle_te_vtt'),
    file: _get(clipdetails, 'subtitle_te_vtt'),
    kind: 'subtitle',
    label: 'తెలుగు',
    id: '14',
    lang: 'telugu'
  };
  const Marathi = {
    url: _get(clipdetails, 'subtitle_mr_vtt'),
    file: _get(clipdetails, 'subtitle_mr_vtt'),
    kind: 'subtitle',
    label: 'मराठी',
    id: '15',
    lang: 'marathi'
  };
  const Malayalam = {
    url: _get(clipdetails, 'subtitle_ml_vtt'),
    file: _get(clipdetails, 'subtitle_ml_vtt'),
    kind: 'subtitle',
    label: 'മലയാളം',
    id: '16',
    lang: 'malyalam'
  };
  const Urdu = {
    url: _get(clipdetails, 'subtitle_ur_vtt'),
    file: _get(clipdetails, 'subtitle_ur_vtt'),
    kind: 'subtitle',
    label: 'اردو',
    id: '17',
    lang: 'urdu'
  };
  const Vietnamese = {
    url: _get(clipdetails, 'subtitle_vi_vtt'),
    kind: 'subtitle',
    label: 'Tiếng Việt',
    id: '18',
    lang: 'vietnamese'
  };

  const subtitlesList = [
    english,
    indonesian,
    malaysian,
    Chinese,
    SChinese,
    TChinese,
    BurmeseUnicode,
    tChinese,
    Arabic,
    Thai,
    Filipino,
    Hindi,
    Tamil,
    Telugu,
    Urdu,
    Marathi,
    Malayalam,
    Vietnamese
  ];
  const actualSubtitlesList = subtitlesList.filter(
    subtitle => subtitle.url !== undefined
  );

  return actualSubtitlesList;
}

export function generateSubtitleTrack(subtitles) {

  let subtitleData = [];

  if (subtitles) {
    subtitles.forEach(function (subtitle) {

      if (subtitle.format == "vtt") {

        let replacer = "https://premiumvideo-internal.vuclip.com";
        let subtitleDataToPush = {
          url: subtitle.url.replace("https://gcpvuclip-a.akamaihd.net", replacer),
          file: subtitle.url.replace("https://gcpvuclip-a.akamaihd.net", replacer),
          kind: 'subtitle',
          label: subtitle.language,
          lang: subtitle.language
        };
        subtitleData.push(subtitleDataToPush);
      }

    })
  }
  return subtitleData;
}
